import React, { useEffect, useState } from 'react';
// If you have react-wordcloud installed, you can use it. Otherwise, use a simple custom renderer.
// import WordCloud from 'react-wordcloud';

// Fallback/mock data
const FALLBACK_THEMES = [
  { text: '#travel', value: 95 },
  { text: '#photography', value: 88 },
  { text: '#frocks', value: 78 },
  { text: '#girl', value: 72 },
  { text: '#fashion', value: 60 },
  { text: '#model', value: 56 },
  { text: '#hot', value: 48 },
  { text: '#design', value: 44 },
  { text: '#usa', value: 39 },
  { text: '#makeup', value: 34 },
  { text: '#brunette', value: 30 },
  { text: '#short', value: 26 },
  { text: '#shorthair', value: 20 },
  { text: '#beautiful', value: 20 },
  { text: '#dance', value: 105 },
  { text: '#coding', value: 55 },
  { text: '#react', value: 45 },
  { text: '#javascript', value: 65 },
  { text: '#css', value: 38 },
  { text: '#html', value: 35 },
  { text: '#python', value: 70 },
  { text: '#ai', value: 90 },
  { text: '#machinelearning', value: 85 },
  { text: '#datascience', value: 82 },
  { text: '#webdevelopment', value: 50 },
  { text: '#mobiledevelopment', value: 48 },
  { text: '#designthinking', value: 40 },
  { text: '#ux', value: 32 },
  { text: '#ui', value: 30 },
  { text: '#cloud', value: 75 },
  { text: '#aws', value: 68 },
  { text: '#azure', value: 66 },
  { text: '#gcp', value: 64 },
  { text: '#cybersecurity', value: 72 },
  { text: '#blockchain', value: 58 },
  { text: '#fintech', value: 52 },
  { text: '#healthtech', value: 54 },
];

async function fetchThemes(query) {
  const url = `https://ai.oigetit.com/AI71/Themes?json=${encodeURIComponent(JSON.stringify({ Query: query }))}`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error('Failed to fetch themes');
    const json = await res.json();
    if (!Array.isArray(json)) throw new Error('Themes API unexpected format');
    return json;
  } catch (err) {
    console.warn('Using fallback themes data:', err);
    return FALLBACK_THEMES;
  }
}

export default function TopThemesPage({ query: initialQuery, setQuery }) {
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [query, setLocalQuery] = useState(initialQuery || '');

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchThemes(query).then(setThemes).catch(e => setError(e.message)).finally(() => setLoading(false));
  }, [query]);

  const handleSearch = () => {
    if (setQuery) {
      setQuery(query);
    } else {
      setLoading(true);
      setError(null);
      fetchThemes(query).then(setThemes).catch(e => setError(e.message)).finally(() => setLoading(false));
    }
  };

  // Simple word cloud renderer (if react-wordcloud is not installed)
  function SimpleWordCloud({ words }) {
    // Scale font size between 18px and 48px
    const max = Math.max(...words.map(w => w.value));
    const min = Math.min(...words.map(w => w.value));
    
    // Generate shades of blue
    const blueShades = [
      '#0D47A1', // Darkest Blue
      '#1565C0',
      '#1976D2',
      '#2196F3',
      '#42A5F5',
      '#64B5F6',
      '#90CAF9',
      '#BBDEFB', // Lightest Blue
    ];
    
    return (
      <div style={{ width: '100%', height: 400, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
        {words.map((w, i) => {
          // Scale font size between a smaller range for a tighter look
          const minSize = 14;
          const maxSize = 40;
          const size = min === max ? (minSize + maxSize) / 2 : minSize + ((w.value - min) / (max - min)) * (maxSize - minSize);
          
          // Determine color based on sorted index, wrapping around if needed
          const color = blueShades[i % blueShades.length];
          
          return (
            <span
              key={w.text + i}
              style={{
                fontSize: size,
                margin: '6px 8px', /* Adjusted margin for tighter spacing */
                color: color,
                fontWeight: 300, // Roboto Light
                opacity: 1,
                lineHeight: 1.4,
                fontFamily: 'Roboto, sans-serif', // Apply Roboto font
                wordBreak: 'break-word',
                cursor: 'pointer',
                userSelect: 'none',
              }}
            >
              {w.text}
            </span>
          );
        })}
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Top Themes</h2>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {loading ? <div>Loading...</div> : (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24, minHeight: 450 }}>
          <h4>Share Of Countries/Region</h4>
          {/* If you have react-wordcloud, use it here. Otherwise use SimpleWordCloud. */}
          {/* <WordCloud words={themes} /> */}
          <SimpleWordCloud words={themes} />
        </div>
      )}
    </div>
  );
} 